import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "share-planner-users-index" }
const _hoisted_2 = {
  key: 0,
  class: "share-planner-users-index__wrapper"
}
const _hoisted_3 = { class: "share-planner-users-index__item-content" }
const _hoisted_4 = { class: "share-planner-users-index__content-title" }
const _hoisted_5 = {
  key: 0,
  class: "share-planner-users-index__content-subtitle"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "share-planner-users-index__item-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "share-planner-users-index__empty"
}
const _hoisted_10 = { class: "share-planner-users-index__empty-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.users.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "share-planner-users-index__item"
            }, [
              _createVNode(_component_PxAvatar, {
                name: user.name,
                photo: user.photo,
                size: 32,
                class: "share-planner-users-index__item-photo",
                styling: "neutral",
                type: "round"
              }, null, 8, ["name", "photo"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(user.name), 1),
                (user.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(user.email), 1))
                  : _createCommentVNode("", true)
              ]),
              (!user.user_profile || user.is_form_owner)
                ? (_openBlock(), _createBlock(_component_ElTag, {
                    key: 0,
                    class: "share-planner-users-index__tag",
                    effect: "light",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tagCopy(user)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_ElTooltip, {
                enterable: false,
                placement: "top",
                "popper-class": "share-planner-users-index__tooltip share-planner-users-index__tooltip--spacious el-abaca-tooltip"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    textContent: _toDisplayString(_ctx.usersCopy.tip)
                  }, null, 8, _hoisted_6)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_PxIcon, {
                    size: 17,
                    class: "share-planner-users-index__tip",
                    name: "question"
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass([{
              'is-disabled': !user.is_form_owner,
            }, "share-planner-users-index__unshare-cta"]),
                  onClick: _withModifiers(($event: any) => (_ctx.unshareClickHandler(user)), ["stop"])
                }, [
                  _createVNode(_component_PxIcon, {
                    size: 14,
                    name: "trash--red"
                  }),
                  _createVNode(_component_PxIcon, {
                    size: 14,
                    class: "px-icon--hover",
                    name: "trash"
                  })
                ], 10, _hoisted_8)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[0] || (_cache[0] = _createElementVNode("picture", { class: "share-planner-users-index__empty-illustration" }, [
            _createElementVNode("img", {
              alt: "Users illustration",
              src: "/img/icons/lists-users-empty-state.svg"
            })
          ], -1)),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.usersCopy.empty), 1)
        ]))
  ]))
}